module.exports = __webpack_public_path__ + "img/about-04-partner-m.d57fba07.png";